import { HttpClient, HttpBackend } from '@angular/common/http';
import { IAppConfig } from './app-config.model';
import { Injectable } from '@angular/core';
import { BehaviorSubject, first } from 'rxjs';

@Injectable()
export class AppConfigService {
    static settings: IAppConfig;
    private http: HttpClient;
    public static callerCount: number = 0;
    private static subjectConfig = new BehaviorSubject<boolean>(false);

    constructor(handler: HttpBackend) {
        this.http = new HttpClient(handler);
    }

  public load() {
        AppConfigService.callerCount++;

        if (AppConfigService.callerCount > 1) {
            return new Promise<any>((resolve) => {
                AppConfigService.subjectConfig.pipe(first(config=> config)).toPromise().then(data => {
                    resolve(AppConfigService.settings);
                });
            });
        }
        
        const jsonFileUrl = `/assets/config/config.json`;
        return new Promise<any>((resolve, reject) => {
            this.http.get(jsonFileUrl).toPromise().then((response: IAppConfig) => {
                AppConfigService.settings = <IAppConfig>response;
                AppConfigService.subjectConfig.next(true);
                resolve(AppConfigService.settings);
            }).catch((response: any) => {
                reject(`Could not load file '${jsonFileUrl}`);
            });
        });
    }
}
